<div class="tbw-dse-palette"
    [class.tbw-dse-floating]="floating"
    [style.left]="(this.headerX + this.headerDx) + 'px'"
    [style.top]="(this.headerY + this.headerDy) + 'px'"
    [style.z-index]="floating ? floatZ : 'auto'">
  <div *ngIf="floating"
      class="tbw-dse-header"
      (mousedown)="headerDragStart($event)"
      (touchstart)="headerDragStart($event)">&nbsp;
    <span *ngIf="showCloser" class="tbw-dse-closer"
        (click)="doCloseAction()" (touchstart)="doCloseAction()">
      <svg viewBox="6 6 12 12" fill="currentColor" stroke="currentColor" width="0.4em" height="0.4em"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </span>
  </div>
  <div #wrapper class="tbw-dse-wrapper"
      [class.tbw-normal-background]="!disabled && !viewOnly"
      [class.tbw-disabled-background]="disabled"
      [class.tbw-view-only-background]="viewOnly"
      [class.tbw-dse-no-focus]="disabled"
      [class.tbw-dse-explicit-focus-outline]="hasFocus && !floating"
      [class.tbw-dse-clear-focus-outline]="!hasFocus"
      [class.tbw-dse-dse-rtl]="rtl"
      [class.tbw-dse-floating]="floating"
      [tabindex]="inputOff || hasHiddenInput ? '-1' : tabindex"
      [attr.contenteditable]="!inputOff && !disableContentEditable"
      [attr.inputmode]="inputOff ? 'none' : fakeUrl ? 'url' : 'decimal'"
      autocomplete="off" autocapitalize="off" autocorrect="off"
      (keydown)="onKeyDown($event)" (keyup)="onKeyUp()" (keypress)="onKeyPress($event)"
      (focus)="onFocus(true, $event)" (blur)="onFocus(false, $event)"
      [ngClass]="getStaticBackgroundColor()"
      (mouseleave)="onMouseLeave()"
      (mouseup)="onMouseUp($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)">
    <div class="tbw-dse-state-indicator" [@displayState]="displayState">&nbsp;</div>
    <div *ngFor="let item of displayItems"
        class="tbw-dse-digit dse-item-{{item.index}}"
        [ngClass]="(getClassForItem(item) || '') + ' ' + (getColorForItem(item) || '')"
        [class.tbw-dse-spinner]="item.spinner"
        contenteditable="false"
        [style.align-items]="getAlignmentForItem(item)"
        [style.color]="blank && (item.editable || item.indicator) ? 'transparent' : undefined"
        [style.cursor]="(item.editable || item.spinner) && !disabled && !viewOnly ? 'pointer' : 'default'"
        [style.line-height]="lineHeight"
        [class.tbw-dse-fade]="item.fade"
        [style.top]="item.divider || item.spinner ? undefined : baselineShift"
        [ngStyle]="item.width ? { width: item.width, 'white-space': 'nowrap', overflow: 'visible' } : null"
        (mousedown)="onMouseDown(item.index, $event)"
        (mouseup)="onMouseUp($event)"
        (contextmenu)="returnFalse()"
        (touchstart)="onTouchStart(item.index, $event)">
      <div class="tbw-dse-backgrounder"
          [ngClass]="getBackgroundColorForItem(item)"
          [style.bottom]="item.spinner || item.divider ? '0' : baselineShift">&nbsp;</div>
      <span *ngIf="swipeable(item, 1)"
          class="tbw-dse-draggable-extra"
          [ngStyle]="getStyleForItem(item, -digitHeight)"
      >{{(item.alt_swipeAbove || item.swipeAbove) ?? '\u00A0'}}</span>
      <span *ngIf="swipeable(item, -1)"
          class="tbw-dse-draggable-extra"
          [ngStyle]="getStyleForItem(item, digitHeight)"
      >{{(item.alt_swipeBelow || item.swipeBelow) ?? '\u00A0'}}</span>
      <span *ngIf="!item.spinner && !item.divider; else dividerOrSpinner"
          class="tbw-dse-draggable dse-item-{{item.index}} {{getCursorMode(item)}}"
          [style.animation-duration]="isSelected(item) && cursorRate"
          [class.tbw-dse-sized]="!!item.sizer"
          [ngStyle]="getStyleForItem(item, 0)"
      >{{filterDisplayChars(item.alt_value || item.value)}}</span>
      <span *ngIf="item.sizer"
          class="tbw-dse-sizer"
      >{{item.sizer}}</span>
      <ng-template #dividerOrSpinner>
        <div *ngIf="item.divider" class="tbw-dse-divider">&nbsp;</div>
        <div *ngIf="item.spinner"
            class="tbw-dse-spinner-layout"
            [class.tbw-dse-wide-spinner]="wideSpinner"
            (mousedown)="onMouseDown(item.index, $event)"
            (touchstart)="onTouchStart(item.index, $event)">
          <svg width="0.574em" height="0.5em" viewBox="0 0 353 307.3">
            <g>
              <path (mousedown)="onMouseDown(SPIN_UP, $event)"
                  (touchstart)="onTouchStart(SPIN_UP, $event)"
                  [ngClass]="(getBackgroundColorForItem(null, SPIN_UP) || '') + ' ' + (getColorForItem(null, SPIN_UP) || '')"
                  d="M 34.1 250.8 L 318.4 250.8 C 336 250.8 334.5 222.4 332.7 208.5 C 332.1 204.2 329.2 197.5 326.6 193.8 L 196.7 28.9 C 185.5 8.6 166.8 8.6 155.9 28.9 L 25.7 193.8 C 23.1 197.5 20.4 204.1 19.9 208.5 C 17.9 222.4 16.5 250.8 34.1 250.8 Z"/>
            </g>
          </svg>
          <svg width="0.574em" height="0.5em" viewBox="0 307.3 353 307.3">
            <g>
              <path (mousedown)="onMouseDown(SPIN_DOWN, $event)"
                  (touchstart)="onTouchStart(SPIN_DOWN, $event)"
                  [ngClass]="(getBackgroundColorForItem(null, SPIN_DOWN) || '') + ' ' + (getColorForItem(null, SPIN_DOWN) || '')"
                  d="M 25.6 419.7 L 155.6 585.1 C 167 605 185.5 605 196.9 585.1 L 327 419.7 C 329.5 416.1 332.2 409.6 332.8 405.3 C 334.6 391 335.9 362.6 318.7 362.6 L 33.8 362.6 C 16.6 362.6 18 391 19.8 405.3 C 20.3 409.6 23.1 416.1 25.6 419.7 Z"/>
            </g>
          </svg>
        </div>
      </ng-template>
    </div>
    <div class="tbw-dse-focus-indicator" [class.tbw-dse-show-focus]="floating && hasFocus">&nbsp;</div>
    <div #emSizer class="tbw-dse-em-sizer">&nbsp;</div>
  </div>
  <div *ngIf="floating" class="tbw-dse-footer">
    <ng-container *ngFor="let btn of buttons; let last = last">
      <span
          class="tbw-dse-button"
          tabindex="-1"
          (click)="onButtonKey(btn.key)"
          (focus)="!showPasteInput && onButtonFocus()"><div [innerHTML]="btn.html || htmlEscape(btn.label)"></div></span>
      <span *ngIf="!last" class="tbw-dse-button-spacer">&nbsp;</span>
    </ng-container>
    <div class="tbw-dse-paste-hint" [style.display]="showPasteInput ? 'block' : 'none'">paste here</div>
    <input name='paste-input'
        type="text"
        (input)="onPasteInput()"
        (blur)="onPasteBlur()"
        [style.display]="showPasteInput ? 'inline-block' : 'none'">
  </div>
</div>
